import { createContext } from "react";
const ParentSheetContext = createContext({
    zIndex: 1e5
  }),
  SheetInsideSheetContext = createContext(null);
export { ParentSheetContext, SheetInsideSheetContext };